export enum AccessRight {
  Read = 'Read',
  ReadWrite = 'ReadWrite',
}

export enum Resource {
  EquipmentPlacementFleet = 'EquipmentPlacementFleet',
  NavigatorCommands = 'NavigatorCommands',
  NodesVideoStreams = 'NodesVideoStreams',
  NodesDataStreams = 'NodesDataStreams',
}

export type Permission = {
  resource: Resource,
  accessRight: AccessRight,
  localityType: string,
};

export const FeatureTypes = ['MuteCommands'] as const;
export type FeatureType = typeof FeatureTypes[number];

export type AuthResponse = {
  accessToken: UserInfo,
  features: { [key in FeatureType]?: boolean }
};

export type UserInfo = {
  userExternalId: string,
  eMail: string,
  groupIds: Array<string>,
  permissions: Array<Permission>,
};
